// routes/ClientChooserRoute.js
import React from "react";
import { Redirect, Route } from "react-router-dom";

const ClientChooserRoute = ({ component: Component, isAuthenticated, isClientSelected, ...children }) => {
  if(!isAuthenticated) {
    return <Redirect to="/login" />
  }

  if(isClientSelected) {
    // Set flag when redirecting to dashboard after client selection
    sessionStorage.setItem("creditPopupNeeded", "true");
    return <Redirect to="/dashboard" />
  }

  return <Route {...children} render={props => <Component {...props} {...children} />} />
};

export default ClientChooserRoute;
